<mat-form-field class="bold-required-field">
  <mat-label>
    {{ fieldLabel }}
  </mat-label>

  <mat-select [formControl]="fieldControl" [attr.test-id]="fieldControl">
    <mat-select-trigger *ngIf="fieldControl.value as triggerValue">
      <span>
        {{ triggerValue }}
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let option of values" [value]="option" [matTooltip]="option.toString()">
      <span>
        {{ option }}
      </span>
    </mat-option>
  </mat-select>

  <mat-error>
    <ui-field-error-messages [control]="fieldControl"></ui-field-error-messages>
  </mat-error>
</mat-form-field>
